/* eslint-disable no-unused-vars */
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index.js';

// Principal Container
const TheContainer = () => import('@/components/TheContainer');
const Dashboard = () => import('@/views/Dashboard');

// TEMPLATE EXAMPLES
const Forms = () => import('../views/template/Forms.vue');
const Cards = () => import('../views/template/Cards.vue');
const Buttons = () => import('../views/template/Buttons.vue');
const Spinner = () => import('../views/template/Spinner.vue');
const Alerts = () => import('../views/template/Alerts.vue');

// VIVOT VIEWS
const Login = () => import('@/views/auth/Login');
const Register = () => import('@/views/auth/Register');
const Profile = () => import('@/views/account/Profile');
const Asset = () => import('@/views/asset/Main');
const AssetView = () => import('@/views/assetView/Main');
const TokensManagement = () => import('@/views/tokens_management/tokensView');

Vue.use(VueRouter);

let router = new VueRouter({
  mode: 'history', // https://router.vuejs.org/api/#mode
  base: process.env.BASE_URL,
  routes: configRoutes(),
});

function configRoutes() {
  return [
    // Todas las rutas que esten definidas dentro de las llaves siguientes
    // se renderizaran dentro de TheContainer, es decir en el espacio donde
    // estan la barra de navegación, el sidebar y el footer
    {
      path: '/',
      redirect: '/dashboard',
      name: 'TheContainer',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          meta: { requiresAuth: true },
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: '/asset',
          meta: { requiresAuth: true },
          name: 'Main',
          component: Asset,
          // beforeEnter(from, to, next) {
          //   if (typeof window.ethereum !== 'undefined') next(true);
          //   else next('/user/account');
          // },
        },
        {
          path: '/assetview',
          meta: { requiresAuth: true },
          name: 'AssetView',
          component: AssetView,
          // beforeEnter(from, to, next) {
          //   if (typeof window.ethereum !== 'undefined') next(true);
          //   else next('/user/account');
          // },
        },
        //vista de tokens
        {
          path: 'Tokens',
          name: 'TokensManagement',
          meta: { requiresAuth: true },
          component: TokensManagement,
          // beforeEnter(from, to, next) {
          //   if (typeof window.ethereum !== 'undefined') next(true);
          //   else next({ path: '/user/account' });
          // },
        },
        {
          path: 'forms',
          name: 'Forms',
          component: Forms,
        },
        {
          path: '/alerts',
          name: 'Alerts',
          component: Alerts,
        },
        {
          path: 'cards',
          name: 'Cards',
          component: Cards,
        },
        {
          path: 'buttons',
          name: 'Buttons',
          component: Buttons,
        },
        {
          path: 'spinner',
          name: 'Spinner',
          component: Spinner,
        },
        // Esta ruta es un hijo que a su vez tiene hijos
        {
          path: 'user',
          //meta: { requiresAuth: true },
          name: 'Account',
          meta: { requiresAuth: true },
          redirect: '/account',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'account',
              name: 'Profile',
              component: Profile,
            },
          ],
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    // Template examples
  ];
}

router.beforeEach((to, from, next) => {
  console.log(to.path);
  const user = JSON.parse(localStorage.getItem('user'));
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({ name: 'Login' });
    } else if (user.walletETH === undefined && to.path !== '/user/account') {
      next({ path: 'user/account' });
    } else {
      next(); // go to wherever I'm going
    }
  } else {
    next(); // does not require auth, make sure to always call next()!
  }
});

export default router;
